<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div>
              <div>
                <span>Add Location Group</span>
              </div>
              <div class="header-subtitle">Add new location group for your organization.</div>
            </div>
          </template>
          <template #multi-action>
            <ul>
              <li class="icon">
                <font-awesome-icon
                  @click="$router.go(-1)"
                  :icon="['fal', 'times']"
                  size="2x"/></li>
            </ul>
          </template>
        </EsHeader>
      </div>
      <div class="content">
        <EsForm>
          <template #es-form>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Group Name</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      :class="{ 'is-danger': hasErrorLabel }"
                      v-model="label"
                      type="text"
                      placeholder="Enter Group Name">
                      <p class="help is-danger">{{ labelMsg }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Code (optional)</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      :class="{ 'is-danger': hasErrorCode }"
                      v-model="code"
                      type="text"
                      placeholder="Enter Code">
                      <p class="help is-danger">{{ codeMsg }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Description (optional)</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      :class="{ 'is-danger': hasErrorDescription}"
                      v-model="description"
                      type="text"
                      placeholder="Enter Description">
                      <p class="help is-danger">{{ descriptionMsg }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Organization</label>
              </div>
              <div class="field-body">
                <div class="field is-narrow">
                  <div class="control">
                    <div
                      class="select is-fullwidth"
                      :class="{ 'is-danger': hasErrorOrganization }">
                      <select class="select-box" v-model="organizationCode">
                        <option
                          value=""
                          disabled
                          selected
                          hidden
                          class="invalid">
                          Select Organization
                        </option>
                        <option
                          v-for="organization in organizations"
                          :key="organization.code"
                          :value="organization.code">
                          {{ organization.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <p class="help is-danger">{{ organizationMsg }}</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Status</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="is-checkradio"
                      v-model="active"
                      id="addGroupTrue"
                      type="radio"
                      checked="checked"
                      :value="true">
                    <label
                      class="radio"
                      for="addGroupTrue">
                      Active
                    </label>
                    <input
                      class="is-checkradio"
                      v-model="active"
                      :value="false"
                      id="addGroupFalse"
                      type="radio">
                    <label
                      class="radio"
                      for="addGroupFalse">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>

          </template>
        </EsForm>
      </div>
      <div class="es-actions">
        <EsFormActions>
          <template #form-actions>
            <div class="bottom-content">
              <ul>
                <li>
                  <div class="list-content">
                    <a @click="$router.push({ name: 'groupList' });">Cancel</a>
                  </div>
                </li>
                <li>
                  <div class="list-content">
                    <label class="checkbox">
                      <input type="checkbox" id="checkbox" @click="toggleAddGroup">
                        Add Another Group
                   </label>
                  </div>
                </li>
                <li>
                  <div class="list-content">
                    <button
                      class="button is-primary"
                      @click.stop.prevent="formValidation">
                        Add Group
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </EsFormActions>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
  faCheckCircle,

  faEdit,
} from '@fortawesome/pro-light-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faTimes,
  faCheckCircle,
  faEdit,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
  },
  data() {
    return {
      name: null,
      code: null,
      description: null,
      organizationCode: '',
      label: null,
      active: true,
      organizations: [],
      messages: [],
      addAnotherGroup: false,
      hasErrorLabel: false,
      hasErrorCode: false,
      hasErrorDescription: false,
      hasErrorOrganization: false,
      hasErrorAPI: false,
      labelMsg: '',
      codeMsg: '',
      descriptionMsg: '',
      organizationMsg: '',
      apiMsg: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
    };
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'groupList' } },
      { text: 'Add Group', to: {} },
    ]);
    this.getOrganizations();
  },
  mounted() {
  },
  methods: {
    async getOrganizations() {
      try {
        const res = await axios.get('organizations');
        this.organizations = res.data;
      } catch {
        // handle error
      }
    },
    toggleAddGroup() {
      this.addAnotherGroup = !this.addAnotherGroup;
    },
    async addLocationGroup() {
      try {
        const res = await axios.post('/location-groups', ({
          description: this.description,
          code: this.code,
          label: this.label,
          active: this.active,
          organizationCode: this.organizationCode,
        }));
        if (this.addAnotherGroup) {
          if (res.status === 200) {
            this.resetForm();
            this.showNotification('success', ['The group has been added successfully.']);
          }
        } else {
          this.$router.push(
            {
              name: 'groupList',
              params: { message: 'The group has been added successfully.', groupId: res.data.id },
            },
          );
        }
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error' : error.response.data.message}`;
        this.messages.push(this.apiMsg);
        this.showNotification('danger', this.messages);
      }
    },
    async formValidation() {
      this.resetErrors();
      let errors = 0;
      this.messages = [];
      if (!this.label || this.label.trim().length === 0) {
        errors += 1;
        this.labelMsg = 'Group Name is required.';
        this.hasErrorLabel = true;
      } else if (this.label.trim().length > 25) {
        errors += 1;
        this.labelMsg = 'Group Name cannot be exceed 25 characters.';
        this.hasErrorLabel = true;
      } else {
        this.label = this.label.trim();
      }
      if (this.code) {
        if (this.code.trim().length > 5) {
          errors += 1;
          this.codeMsg = 'Group Code cannot be exceed 5 characters.';
          this.hasErrorCode = true;
        } else {
          this.code = this.code.trim();
        }
      }
      if (this.description) {
        if (this.description.trim().length > 128) {
          errors += 1;
          this.descriptionMsg = 'Description cannot be exceed 128 characters.';
          this.hasErrorDescription = true;
        } else {
          this.description = this.description.trim();
        }
      }
      if (!this.organizationCode) {
        errors += 1;
        this.organizationMsg = 'Organization is required.';
        this.hasErrorOrganization = true;
      }
      if (errors > 0) {
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      } else {
        this.addLocationGroup();
      }
    },
    resetForm() {
      this.label = null;
      this.code = null;
      this.description = null;
      this.organizationCode = '';
      this.active = true;
    },
    resetErrors() {
      this.messages = [];
      this.hasErrorLabel = false;
      this.hasErrorOrganization = false;
      this.hasErrorCode = false;
      this.hasErrorDescription = false;
      this.hasErrorAPI = false;
      this.labelMsg = '';
      this.codeMsg = '';
      this.descriptionMsg = '';
      this.organizationMsg = '';
      this.apiMsg = '';
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 928px
  .list-content
    white-space: nowrap
  .label.checkbox
    padding-right: 15px
    padding-top: 2px
  .select
    min-width: 50%
    select
      min-width: 100%
</style>
